import axios from 'axios'

import { useAuthStore } from '@/store/auth'
import { useOrganizationsStore } from '@/store/organizations'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL
})

api.interceptors.request.use(
  config => {
    const { accessToken } = useAuthStore()
    const { selectedOrganization, selectedLocation } = useOrganizationsStore()

    if (accessToken) config.headers['Authorization'] = accessToken
    if (selectedOrganization) config.headers['Organization-ID'] = selectedOrganization.id
    if (selectedLocation && selectedLocation.id !== -1)
      config.headers['Location-ID'] = selectedLocation.id
    return config
  },

  error => {
    return Promise.reject(error)
  }
)

export default api
